'use client';

import classnames from 'classnames';

import type { TimelineProps } from './Timeline.types';
import { TimelineSlot } from './layout/TimelineSlot';

import styles from './Timeline.module.scss';

function Timeline({
  style,
  className,
  slots,
  direction = 'vertical',
  testId = 'ui-timeline',
  onOpenSlot,
  onCloseSlot,
}: TimelineProps) {
  return (
    <div
      style={style}
      className={classnames(styles['timeline'], className)}
      data-testid={testId}
    >
      <div
        className={classnames(
          styles['slot'],
          direction && styles[`slot--${direction}`],
          className,
        )}
      >
        {slots.map((slot, index) => {
          return (
            <TimelineSlot
              key={index}
              title={slot.title}
              description={slot.description}
              payload={slot.payload}
              payloadDefaultOpen={slot.payloadDefaultOpen}
              date={slot.date}
              last={index == slots.length - 1}
              icon={slot.icon}
              direction={direction}
              testId={`${testId}_slot-${slot.id}`}
              onOpenSlot={() => onOpenSlot?.(slot.id)}
              onCloseSlot={() => onCloseSlot?.(slot.id)}
            />
          );
        })}
      </div>
    </div>
  );
}

export { Timeline };
